const featureFlags = {
  enableAuthentication: "isAuthenticationEnabled",
  enablePspPage: "isPspPickerPageEnabled",
  enableMaintenance: "isMaintenancePageEnabled",
  enableScheduledMaintenanceBanner: "isScheduledMaintenanceBannerEnabled",
  enablePaymentMethodsHandler: "isPaymentMethodsHandlerEnabled",
  enableWallet: "isPaymentWalletEnabled",
};

export default featureFlags;
